import Phaser, { Display } from 'phaser'
import Carrot from './game/Carrot'
import GameOverScene from './GameOverScene'
import WinScene from './WinScene'
import StartScene from './StartScene'
let player
let platforms
let cursors
let carrots
let carrotsCollected
export default class BunnyJumpScene extends Phaser.Scene {

    constructor(){
        super('bunny-jump-scene')
    }

    preload(){
        this.load.image('background', 'images/bg_layer1.png')
        this.load.image('platforms', 'images/ground_grass.png')
        this.load.image('carrot','images/carrot.png')
        this.load.image('bunny_jump','images/bunny1_jump.png')
        this.load.image('bunny_stand','images/bunny1_stand.png')
        this.load.audio('jumpSound', 'sfx/phaseJump1.ogg')
    }

    create(){
        this.add.image(240, 320, 'background').setScrollFactor(1, 0)

        this.platforms = this.physics.add.staticGroup()

        for (let i = 0 ; i<5 ; i++) {//mengulangi 5 kali
            //x bernilai random dari 80-400
            const X = Phaser.Math.Between(80, 400)
            const Y = 150 * i //platforms berjarak 150 pixel

            //membuat platforms
            const platformsChild = this.platforms.create(X, Y, 'platforms')
            platformsChild.setScale(0.5) //mengecilkan platforms
            platformsChild.refreshBody() //meresahkan platforms
            
            const body =  platformsChild.body
            body.updateFromGameObject()
        }

        this.player = this.physics.add.sprite(240, 320, 'bunny_stand').setScale(0.4)
        
        this.physics.add.collider(this.player, this.platforms)

        //mematikan colison player pada bagian atas, kiri dan kanan
        this.player.body.checkCollision.up = false
        this.player.body.checkCollision.left = false
        this.player.body.checkCollision.right = false

        //membuat kamera mengikuti player
        this.cameras.main.startFollow(this.player)

        this.cursors = this.input.keyboard.createCursorKeys()

        

        //atur dead zone dengan nilai lebar layout dikalikan 1*5
        this.cameras.main.setDeadzone(this.scale.width *1.5)

        this.carrots = this.physics.add.group({
            classType: Carrot
        })

        //platforms berbenturan dengan carrots
        this.physics.add.collider(this.platforms, this.carrots)

        this.physics.add.overlap(
            this.player, 
            this.carrots, 
            this.handleCollectCarrot, 
            undefined, 
            this
        )

        this.carrotsCollected = 0

        const style = {color: '#DFFF00', fontSize:30}
        //tambahan code lagiii
        // @ts-ignore
        this.carrotsCollectedText = this.add.text(240, 10, 'Carrots:0', style)  
                .setScrollFactor(0)
                .setOrigin(0.5, 0)
    }

    update(){

        //variabel lokal untuk memastikan player menyentuh tanah
        const touchingDown = this.player.body.touching.down

        //kondisi jika player menyentuh bawah
        if(touchingDown){
            //maka player akan meloncat dengan percepatan -300
            this.player.setVelocityY(-300) //-300 karena semakin minus semakin keatas

            //dan berubah menjadi animasi lompat
            this.player.setTexture('bunny_jump')

            //jika player menyentuh bawah tanah
            this.sound.play('jumpSound')
        }

        //mencari percepatan player
        const vy = this.player.body.velocity.y

        //jika percepatan lebih dari 0 dan animasi player bukan stand/berdiri
        if (vy > 0 && this.player.texture.key !== 'bunny_stand') {
            //animasi buat player berdiri / stand
            this.player.setTexture('bunny_stand')

        }

        //cursor left and right
        if (this.cursors.left.isDown && !touchingDown){
            this.player.setVelocityX(-200)
        } else if (this.cursors.right.isDown && !touchingDown) {
            this.player.setVelocityX(200)
        } else {
            this.player.setVelocityX(0)
        }

        this.platforms.children.iterate(child => {
            const platformsChild = child
            
            const scrollY = this.cameras.main.scrollY
        //@ts-ignore
            if (platformsChild.y >= scrollY +708) {
                //@ts-ignore
                platformsChild.y =scrollY - Phaser.Math.Between(50, 100)
                //@ts-ignore
                platformsChild.body.updateFromGameObject()

                //panggil
                this.addCarrotAbove(platformsChild)
            }
        })
        
        this.horizontalWrap(this.player)

        const bottomPlatform = this.findBottomMostPlatform()
        // @ts-ignore
        if (this.player.y > bottomPlatform.y + 300) {
            this.scene.start('game-over-scene')
        }
        
        if (this.carrotsCollected === 10){
            this.scene.start('win-scene')
        }
        
    }

    //buat method dengan parameter sprite
    horizontalWrap(sprite) {
        const halfWidth = sprite.displayWidth * 0.5
        const gameWidth = this.scale.width
        if (sprite.x < -halfWidth) {
            sprite.x = gameWidth + halfWidth
        } else if  (sprite.x > gameWidth + halfWidth) {
            sprite.x = -halfWidth
        }
    }

    addCarrotAbove(sprite) {
        const y = sprite.y - sprite.displayHeight
        const carrot = this.carrots.get(sprite.x, y, 'carrot')

        //tambahan 2 baris kode
        carrot.setActive(true) //menyalakan carrot
        carrot.setVisible(true) //menampilkan carrot

        //menambahkan fisik dari carrot
        this.add.existing(carrot)
        carrot.body.setSize(carrot.width, carrot.height)

        //tambahan 1 baris kode
        this.physics.world.enable(carrot)

            return carrot
    
    }

    handleCollectCarrot(player, carrot) {
        this.carrots.killAndHide(carrot)
        this.physics.world.disableBody(carrot.body)

        this.carrotsCollected++

        const value = `Carrots: ${this.carrotsCollected}`
        this.carrotsCollectedText.text = value
    }

    findBottomMostPlatform() {
        const platforms = this.platforms.getChildren()

        let bottomPlatform = platforms[0]

        for (let i=1; i<platforms.length; i++) {
            const platform = platforms[i]

            // @ts-ignore
            if (platform.y < bottomPlatform.y){
                continue
            }
            bottomPlatform = platform
        }
        return bottomPlatform
    }
}